import { ChatCopyGuest } from '@commons/chat-assistance/models/chat-copy-guest';

import { Option } from '@contact/upgrade';

import { ChatGuest, IChatGuest } from './chat-guest';

export type MessageDirection = 'IN' | 'OUT';

export interface IChatMessage {
  roomId: string;
  timestamp: number;
  from: IChatGuest;
  copyGuest: ChatCopyGuest;
  to: IChatGuest[];
  direction: MessageDirection;
  content: string;
  isRead: boolean;
}

export class ChatMessage {
  static fromDto(dto): IChatMessage {
    return {
      roomId: dto.id,
      timestamp: dto.dateTime,
      direction: dto.direction,
      content: dto.message,
      from: ChatGuest.fromDto(dto.from),
      copyGuest: dto.copyGuest,
      to: Option.of(dto.to)
        .getOrElse([])
        .map(guestDto => ChatGuest.fromDto(guestDto)),
      isRead: false,
    };
  }

  static toDto(message: IChatMessage): any {
    return {
      id: message.roomId,
      dateTime: message.timestamp,
      direction: message.direction,
      message: message.content,
      from: ChatGuest.toDto(message.from),
      copyGuest: message.copyGuest,
      to: message.to.map(guest => ChatGuest.toDto(guest)),
    };
  }
}
